var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_307",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28876",
    "data-name": "Group 28876",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_307)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_307-2",
    "data-name": "Ellipse 307",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-16_13_",
    "data-name": "svgexport-16 (13)",
    transform: "translate(13 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49076",
    "data-name": "Path 49076",
    d: "M34.552.2,21.875,6.93a1.076,1.076,0,0,0-.571.95V24.773a1.811,1.811,0,0,0,.992,1.615l12.431,6.3a1.4,1.4,0,0,0,1.262,0l12.431-6.3a1.811,1.811,0,0,0,.992-1.615V7.881a1.076,1.076,0,0,0-.572-.95L36.164.2a1.719,1.719,0,0,0-1.612,0Z",
    transform: "translate(-21.304 0)",
    fill: "#ffce94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49077",
    "data-name": "Path 49077",
    d: "M147.724,91.9a1.394,1.394,0,0,0,.631-.151l12.431-6.305a1.811,1.811,0,0,0,.992-1.615V66.933a1.073,1.073,0,0,0-.123-.495l-13.931,7.42Z",
    transform: "translate(-133.67 -59.052)",
    fill: "#fcb043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49078",
    "data-name": "Path 49078",
    d: "M35.358,73.857l-13.931-7.42a1.071,1.071,0,0,0-.123.495V83.824A1.811,1.811,0,0,0,22.3,85.44l12.431,6.3a1.394,1.394,0,0,0,.631.151V73.857Z",
    transform: "translate(-21.304 -59.051)",
    fill: "#e2791b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49079",
    "data-name": "Path 49079",
    d: "M79.677,21.673l-14.1,7.508v2.4a.624.624,0,0,0,.331.551l2.45,1.306a.292.292,0,0,0,.429-.258V30.94l14.12-7.552Z",
    transform: "translate(-60.657 -19.264)",
    fill: "#def2fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49080",
    "data-name": "Path 49080",
    d: "M165.993,223.107l3.761-1.8a1.356,1.356,0,0,0,.77-1.255v-.017a.6.6,0,0,0-.87-.517l-3.662,1.881v1.707Zm0,2.623,2.065-.96a1.356,1.356,0,0,0,.784-1.262.6.6,0,0,0-.872-.515l-1.977,1.029Z",
    transform: "translate(-149.908 -195.057)",
    fill: "#403a46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49081",
    "data-name": "Path 49081",
    d: "M65.578,89.429v2.378a.624.624,0,0,0,.331.551l2.45,1.306a.292.292,0,0,0,.429-.258V91.164l.024-.013Z",
    transform: "translate(-60.656 -79.487)",
    fill: "#b6c8ce"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.6f1a0bcf530dda5ce0cfc00b2e5baf3a.svg";
export { ForwardRef as ReactComponent };